import { useContext, useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import SubscriptionStatusContext from "../context/SubscriptionStatusContext";
import { SubscriptionStatus } from "../lib/types";

export enum UserState {
  uninitialized,
  loading,
  unauthenticated,
  canRegisterForTrial,
  paymentRequired,
  subscribed,
}

const useUserState = () => {
  const [userState, setUserState] = useState<UserState>(
    UserState.uninitialized
  );
  const { user, loading } = useAuth();
  const subscriptionInfo = useContext<SubscriptionStatus | null>(
    SubscriptionStatusContext
  );

  useEffect(() => {
    if (loading) {
      setUserState(UserState.loading);
      return;
    }

    if (!user) {
      setUserState(UserState.unauthenticated);
      return;
    }

    if (subscriptionInfo === null) {
      setUserState(UserState.loading);
      return;
    }

    if (subscriptionInfo.subscription.basic.hasSubscription) {
      setUserState(UserState.subscribed);
      return;
    }

    if (subscriptionInfo.subscription.basic.hasTrial) {
      setUserState(UserState.canRegisterForTrial);
      return;
    }

    setUserState(UserState.paymentRequired);
  }, [user, loading, subscriptionInfo]);

  return { userState, setUserState, subscriptionInfo };
};

export default useUserState;
